import { connect } from 'react-redux';
import { canCreateMaterials } from '@core/materials/permissions';
import GetStarted from './GetStarted';

const mapStateToProps = (state) => ({
  editable: canCreateMaterials(state),
});

const GetStartedContainer = connect(mapStateToProps)(GetStarted);

export default GetStartedContainer;
